/**
 * @generated SignedSource<<601bc203f4b614893064b09ed0b3bd1d>>
 * @relayHash e023a7ebabd8ecb1e9f44a4954812853
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e023a7ebabd8ecb1e9f44a4954812853

import { ConcreteRequest } from 'relay-runtime';
export type useDeMedicationDetailByIdQuery$variables = {
  id: string;
  skip: boolean;
};
export type useDeMedicationDetailByIdQuery$data = {
  readonly de_medicationDetailById?: {
    readonly result?: {
      readonly canDelete: boolean | null;
      readonly id: string;
    };
  };
};
export type useDeMedicationDetailByIdQuery = {
  response: useDeMedicationDetailByIdQuery$data;
  variables: useDeMedicationDetailByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "de_Medication",
      "kind": "LinkedField",
      "name": "result",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canDelete",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "de_SuccessMedicationDetailResult",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeMedicationDetailByIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "de_medicationDetailById",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeMedicationDetailByIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "de_medicationDetailById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e023a7ebabd8ecb1e9f44a4954812853",
    "metadata": {},
    "name": "useDeMedicationDetailByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5a811821a6fa26c48645084d1a641f36";

export default node;
